import {
  anyPaymentMethodModel,
  anyUserPaymentMethodsModel,
} from "@/feature-wallet/models/any-payment-method.mjs";
import { paymentPlanModel } from "@/feature-wallet/models/payment-plans.mjs";
import { subscriptionCouponModel } from "@/feature-wallet/models/subscription-coupon.mjs";
import { userSubscriptionModel } from "@/feature-wallet/models/user-subscriptions.mjs";
import { userTransactionModel } from "@/feature-wallet/models/user-transactions.mjs";
import gql from "@/util/graphql-query.mjs";

export const transactions = gql`
  query GetUserTransactions {
    userPaymentInfo { paymentInvoices { ${userTransactionModel} } }
  }
`;

export const paymentMethods = gql`
  query GetUserPaymentMethods {
    userPaymentInfo { paymentProviders { ${anyUserPaymentMethodsModel} } }
  }
`;

export const subscriptions = gql`
  query GetUserSubscriptions {
    userPaymentInfo { paymentSubscriptions { ${userSubscriptionModel} } }
  }
`;

export const paymentPlans = gql`
  query GetPaymentPlans {
    paymentPlans { ${paymentPlanModel} }
  }
`;

export const createBraintreeClientToken = gql`
  mutation CreateBraintreeClientToken {
    createBraintreeClientToken
  }
`;

export const postPaymentMethod = gql`
  mutation CreatePaymentMethod($isDefault: Boolean, $paymentMethodId: ID!, $providerType: PaymentProviderType!, $testClock: String){
    createPaymentMethod(isDefault: $isDefault, paymentMethodId: $paymentMethodId, providerType: $providerType, testClock: $testClock) {
      ${anyPaymentMethodModel}
    }
  }
`;

export const checkCoupon = gql`
  query checkCoupon($couponCode: String!, $providerType: PaymentProviderType!) {
    checkCoupon(couponCode: $couponCode, providerType: $providerType){
      ${subscriptionCouponModel}
    }
  }
`;

export const removePaymentMethod = gql`
  mutation RemovePaymentMethod(
    $paymentMethodId: ID!
    $providerType: PaymentProviderType!
  ) {
    removePaymentMethod(
      paymentMethodId: $paymentMethodId
      providerType: $providerType
    )
  }
`;

export const updateDefaultPayment = gql`
  mutation updateDefaultPayment(
    $paymentMethodId: ID!
    $providerType: PaymentProviderType!
  ) {
    updateDefaultPayment(
      paymentMethodId: $paymentMethodId
      providerType: $providerType
    ) {
      id
    }
  }
`;

export const updateSubscription = gql`
  mutation UpdateSubscription($paymentMethodId: ID!, $plan: SubscriptionPaymentPlanType!) {
    updateSubscription(paymentMethodId: $paymentMethodId, plan: $plan) { ${userSubscriptionModel} }
  }
`;

export const cancelSubscription = gql`
  mutation CancelSubscription($cancellationReason: String!, $plan: SubscriptionPaymentPlanType!) {
    unsubscribeFromPlan(cancellationReason: $cancellationReason, plan: $plan) { ${userSubscriptionModel} }
  }
`;
